// File: CategoryHeader.js
import React from "react";
import { ClipboardList } from "lucide-react";
import { capitalizeWords } from "../../utils";

const CategoryHeader = ({ category, profileCount }) => {
  return (
    <div className="px-3 py-4 sm:px-4 md:px-6 md:py-5 bg-gradient-to-r from-indigo-50 to-white border-b border-gray-200">
      <h3 className="text-base md:text-lg font-medium text-gray-900 flex items-center flex-wrap gap-2">
        <ClipboardList className="h-4 w-4 flex-shrink-0" />
        <span>{capitalizeWords(category)} Profiles</span>
        <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-500/10">
          {profileCount}
        </span>
      </h3>
      <p className="mt-1 max-w-2xl text-sm text-gray-500"></p>
    </div>
  );
};

export default CategoryHeader;
